export enum ItemPropertyType {
	ACE_EDITOR,
	CHECKBOX,
	COLUMNS,
	COLUMNS_WITH_ORDER,
	CUSTOM_JSX,
	FOREIGN_KEY,
	GENERATED_CODE,
	HIDDEN,
	NUMBER,
	OPTION,
	OPTIONS,
	REGEXP_VALIDATED,
	SECRET,
	TEXT,
	TEXTAREA,
	ASYNC_SELECT,
}

export enum Position {
	Top,
	Left,
	Bottom,
	BottomLeft,
}

export enum TabName {
	DeploymentPackage = 'DeploymentPackage',
	Diagram = 'Diagram',
}

export enum Environment {
	Cez = 'cez',
	Dev = 'dev',
	Docker = 'docker',
	Drmax = 'drmax',
	Gasnet = 'gasnet',
	Privatbank = 'privatbank',
}

export enum LsKey {
	DeletedNodes = 'DELETED_NODES',
}

export enum PageType {
	COLUMN_PAGE = 'COLUMN_PAGE',
	OVERVIEW_PAGE = 'OVERVIEW_PAGE',
}

export enum StereoTypeColumnEnum {
	VirtualColumn = 37,
	InterfaceColumn = 8,
	HistoryColumn = 7,
	DummyColumn = 5,
	Constant = 4,
	AuditColumn = 3,
}
export enum StereoTypeColumnCodeEnum {
	VirtualColumn = 'VIRTUAL_COLUMN',
}

export enum ConstraintTypeEnum {
	CHECK = 'check',
	CUSTOM = 'custom',
	FOREIGN_KEY = 'foreign_key',
	PRIMARY_KEY = 'primary_key',
	UNIQUE = 'unique',
}

export enum AsyncTechnicalColumnUpdateType {
	MASS_UPDATE = 'MASS_UPDATE',
	UPDATE_TECHNICAL_COLUMNS = 'UPDATE_TECHNICAL_COLUMNS',
}
